// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"f043bc08","242":"e02cd7f4","283":"63040a7d","469":"72f56e29","642":"d3bef15b","732":"08f8c9af","736":"44a87af9","767":"c862abcf","955":"ce4ba9c8"}[chunkId] + ".chunk.js";
};